module.exports = __webpack_public_path__ + "img/motorway_4x3_z16.80981850.svg";